import store from '../store'




import {
	mapState,
	mapMutations,
	mapActions
} from 'vuex'


export default {
	props: [
		'mode',
		'propParams', 'propForm', 'propData',
		'propCategoryId', 'propProductId',
		'propStationId', 'propRobotId',
		'propOrderId', 'propTaskId',
		'propStationName', 'propRobotName',
		'propRobotInfo'
	],
	data() {
		return {
			origin: request.origin,
		}
	},
	computed: {
		...mapState(['sm',
			'isLogin', 'token', 'userId', 'userInfo', 'localHouseInfo', 'vipInfo', 'config', 'notices', 'citys',
			''
		]),
		isSystemAdmin() {
			return this.userInfo && this.userInfo.role == 'SYSTEM_ADMIN';
		},
		isStationAdmin() {
			return this.userInfo && this.userInfo.role == 'STATION_ADMIN';
		},

	},
	methods: {
		...mapMutations(['setLogin', 'setLogout']),
		...mapActions(['initLogin', 'initConfig', 'initService', 'wxXcxLogin']),
		alert(content) {
			// alert(content)
			dialogs.open('Pre', {
				content
			})
		},
		goTo(url, auth, i18n) {
			if (i18n) {
				url = `/${this.$i18n.locale}${url}`
			}
			if (auth && !store.state.isLogin) {
				this.$router.push('/login')
				return;
			}
			this.$router.push(url)
		},
		reTo(url, auth) {
			if (auth && !store.state.isLogin) {
				this.$router.push('/login')
				return;
			}
			this.$router.replace(url)
		},
		openTo(url, auth) {
			if (auth && !store.state.isLogin) {
				this.$router.push('/login')
				return;
			}
			window.open(`#` + url)
		},
		goTab(url) {
			uni.switchTab({
				url
			})
		},
		goBack() {
			this.$router.back()
		},
		goHome() {
			this.$router.replace('/')
		},


		downloadFile(url, filename) {
			console.log('downloadFile', url, filename)
			const a = document.createElement('a');
			a.href = url;
			a.download = filename || url.split('/').pop();
			a.target = '_blank';
			document.body.appendChild(a);
			a.click();
			setTimeout(() => {
				document.body.removeChild(a);
				if (a.href.startsWith('blob:')) {
					URL.revokeObjectURL(a.href);
				}
			}, 0);
		},

		tts(options) {
			request({
				url: '/api/chat/tts',
				data: {
					...options.params
				},
				success: resp => {
					dialogs.open('AudioPlayer', {
						url: config.origin + resp.data.path
					})
				}
			})
		},

		success(message) {
			this.$message({
				message: message || this.$t('saima.success'),
				type: 'success',
				offset: 120,
				center: true,
			});
		},

		error(message) {
			this.$message.error(message || this.$t('saima.error'));
		},

		info(message) {
			this.$message(message);
		},

		switchLanguage(lang) {
			// 如果要切换的语言与当前语言相同，则不做处理
			if (lang === this.currentLang) return

			// 更新i18n的locale
			this.$i18n.locale = lang

			// 更新路由，保持路径其余部分不变，只修改语言参数
			this.$router.push({
				name: this.$route.name,
				params: {
					...this.$route.params,
					lang: lang
				}
			})


			if (window.gtag && location.host.includes('jp.emoka.co')) {
				gtag('event', 'switch_language', {
					'page_url': window.location.href
				});
			}


		},





	},
}